import React from 'react'

import {
StyledCard
} from './styles'

export default function ContactCard({ network, person, number }) {
    return (
        <StyledCard>
            <h4>{network}</h4>
            <p>{person}</p>
            <p>{number}</p>
        </StyledCard>
    )
}